export const loadingSlideKeys = {
  active: ['loading-slides', 'active'] as const,
  all: ['loading-slides'] as const,
}
